import { useReveal } from '../hooks/useReveal.js';
import { Ornament } from '../components/Ornament.js';

function P({ children, delay = 0 }: { children: React.ReactNode; delay?: number }) {
  const ref = useReveal<HTMLParagraphElement>(0.3);
  return (
    <p
      ref={ref}
      className="ow-reveal text-secondary"
      style={
        {
          fontSize: 17,
          lineHeight: 1.8,
          ['--reveal-delay' as never]: `${delay}ms`,
        } as React.CSSProperties
      }
    >
      {children}
    </p>
  );
}

export function Manifesto() {
  const headerRef = useReveal<HTMLDivElement>(0.3);
  const leadRef = useReveal<HTMLParagraphElement>(0.3);

  return (
    <section id="manifesto" className="relative w-full" style={{ padding: '80px 20px 64px' }}>
      <div className="mx-auto" style={{ maxWidth: 920 }}>
        <div ref={headerRef} className="ow-reveal">
          <p
            className="font-display uppercase text-gold"
            style={{ fontSize: 11, letterSpacing: '0.32em' }}
          >
            § I - The Invitation
          </p>
          <h2
            className="font-display text-primary mt-5"
            style={{
              fontSize: 'clamp(40px, 5vw, 56px)',
              fontWeight: 500,
              letterSpacing: '0.02em',
              lineHeight: 1.1,
            }}
          >
            Not an app. A way.
          </h2>
        </div>

        <p
          ref={leadRef}
          className="ow-reveal scripture text-secondary mt-10"
          style={
            {
              fontSize: 22,
              lineHeight: 1.55,
              ['--reveal-delay' as never]: '120ms',
            } as React.CSSProperties
          }
        >
          For two thousand years, the Orthodox Church has carried a way of life, prayer at sunrise
          and sunset, fasts that turn the seasons, feasts that remember the saints, scripture spoken
          in every cell and every cathedral.
          <br />
          <br />
          Orthodox Way is that life, gently, on the device already in your hand.
        </p>

        <Ornament symbol="✦" />

        <div className="space-y-6">
          <P delay={0}>
            The Church has never lacked depth. What it has sometimes lacked is a quiet companion,
            something that knows what day it is on the calendar of saints, what fasting rule
            applies, which Gospel will be read at Liturgy, and what tone the choir is in this week.
          </P>
          <P delay={150}>
            Orthodox Way is that companion. A liturgical engine at its heart, a library of prayers
            in its hands, and the rhythm of the Church year woven through every screen.
          </P>
          <P delay={300}>
            We built it the way an icon is written: slowly, carefully, with reverence.
          </P>
        </div>
      </div>
    </section>
  );
}
